import { createContext, useState, useContext } from "react";
import PagesRouter from "./router/PagesRouter"
import { CustomerProvider } from "./customHooks/useCustomer"
import Cookiebot from "./components/Cookiebot/Cookiebot";
import UnderMaintenance from "./pages/UnderMaintenance/UnderMaintenance";
import { clientConfig } from "./config";
import BonusBanner from "./components/BonusBanner/BonusBanner";
import AndroidAppBar from "./components/AndroidAppBar/AndroidAppBar";
import { CartProvider } from "./customHooks/useCart";

import "./App.css"
import { AppProvider } from "./providers/AppProvider";

export const LocationContext = createContext();

export function useLocationContext() {
  return useContext(LocationContext);
}

function App() {
  const [location, setLocation] = useState(null)


  const locationProviderState = {
    location,
    setLocation
  }

  if (clientConfig.IS_UNDER_MAINTENANCE === "true") {
    return <UnderMaintenance />

  } else {
    return (
        <div id="client-app-root">
          <AppProvider>
            <CartProvider>
              <CustomerProvider>
                <LocationContext.Provider value={locationProviderState}>
                  {/* Modal Root */}
                  <div id="modal-root" />
                  <BonusBanner />
                  <AndroidAppBar />
                  <PagesRouter>
                  </PagesRouter>
                  <Cookiebot />
                </LocationContext.Provider>
              </CustomerProvider>
            </CartProvider>
          </AppProvider>
        </div>
    );
  }


}

export default App;
